import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import ReactDOM from "react-dom";
import { Chat42Error } from "@/core/error";
import { useRouteHandler } from "@/hook";
import Button from "@/component/Button";
import ErrorIcon from "@/assets/svgs/error_monitor.svg";


type ErrorViewProps = {
    description: string;
    customReset?: () => void;
    resetErrorBoundary?: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = (props) => {
    const { description, customReset, resetErrorBoundary } = props;

    const intl = useIntl();
    const { resetRoute } = useRouteHandler();

    const onClickReturnHome = () => {
        if (customReset) {
            customReset();
        } else {
            resetRoute();
            setTimeout(() => {
                resetErrorBoundary?.();
            }, 0);
        }
    };

    useEffect(() => {
        window.addEventListener("popstate", () => resetErrorBoundary?.());

        return () => {
            window.removeEventListener("popstate", ()=> resetErrorBoundary?.());
        };
    }, [resetErrorBoundary]);

    return ReactDOM.createPortal((
        <div className="h-screen mx-auto bg-black-100 flex flex-col items-center justify-center">
            <div className="w-[464px] h-96 p-24 pt-20 flex items-center justify-center bg-white rounded-[16px] border border-black-200">
                <div className="flex flex-col gap-12">
                    <div className="flex flex-col gap-4 items-center">
                        <img src={ErrorIcon}
                             alt="error"
                             className="size-20"
                        />
                        <div className="font-[600] text-[16px] leading-[1.2] text-black-500">
                            {description}
                        </div>
                    </div>

                    <Button variant="primary"
                            size="full"
                            onClick={onClickReturnHome}
                    >
                        {intl.formatMessage({ id: "e0001" })}
                    </Button>
                </div>
            </div>
        </div>
    ), document.getElementById('portal')!);
};

export const Error404View: React.FC = () => {
    throw new Chat42Error('404');
};

export default ErrorView;
